import React from 'react'
import Skills from '../components/main/Skills'

function SkillsPage() {
  return (
    <div>
        <Skills/>
    </div>
  )
}

export default SkillsPage
